<template>
  <div class="con-wrap">
    <div class="top">
      <el-button type="primary" @click="goback">返回</el-button>
    </div>
    <div class="con-wrap-inner">
      <el-aside width="300px" class="left-con">
        <!-- <el-row class="sub-title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">围栏名称</div>
          </el-col>
          <el-col :span="2" :offset="6"></el-col>
        </el-row> -->
        <el-form ref="fenceForm" :model="fenceForm" size="medium" :inline="true" class="input-form-inline">
          <p>围栏名称</p>
          <el-form-item prop="name">
            <el-input v-model="fenceForm.name" placeholder="请输入站址名称"></el-input>
          </el-form-item>
          <p>选择车辆</p>
          <el-form-item prop="PlateList">
            <el-input v-model="fenceForm.PlateList" :title="fenceForm.PlateList" placeholder="请选择车辆"
              @click.native="clickInput" readonly></el-input>
          </el-form-item>
          <p>围栏类型</p>
          <el-form-item class="radios" prop="monitorType">
            <el-radio-group v-model="fenceForm.monitorType">
              <el-radio label="1">驶入监控</el-radio>
              <el-radio label="2">驶出监控</el-radio>
            </el-radio-group>
          </el-form-item>
          <p>监控区域</p>
          <el-form-item class="radios" prop="shapeType">
            <el-radio-group v-model="fenceForm.shapeType" @change="fenceType">
              <el-radio label="1">圆形</el-radio>
              <el-radio label="2">多边形</el-radio>
              <el-radio label="4">行政区域</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="this.fenceForm.shapeType == 4" prop="adcode">
            <el-cascader :options="areaOptions" :props="optionProps" v-model="adcode" @change="getAdcode"></el-cascader>
          </el-form-item>
          <p>开始时间</p>
          <el-form-item prop="startTime">
            <el-time-picker placeholder="开始时间" v-model="fenceForm.startTime" :clearable="false" format="HH:mm"
              value-format="HH:mm" :picker-options="{
                selectableRange: `00:00:00 -${fenceForm.endTime ? fenceForm.endTime + ':00' : '23:59:00'
                  }`,
              }" style="width: 100%"></el-time-picker>
          </el-form-item>
          <p>结束时间</p>
          <el-form-item prop="endTime">
            <el-time-picker placeholder="结束时间" v-model="fenceForm.endTime" :clearable="false" format="HH:mm"
              value-format="HH:mm" :picker-options="{
                selectableRange: `${fenceForm.startTime ? fenceForm.startTime + ':00' : '00:00:00'
                  }-23:59:00`,
              }" style="width: 100%"></el-time-picker>
          </el-form-item>
          <p>状态</p>
          <el-form-item class="radios" prop="monitorStatus">
            <el-switch v-model="fenceForm.monitorStatus" active-color="#0094FF" active-text="开" inactive-text="关"
              inactive-color="#999" active-value="1" inactive-value="2">
            </el-switch>
          </el-form-item>
          <el-form-item class="btn">
            <el-button v-if="hasPerm('vehicle:model:list')" type="primary" @click="saveFence">保存设置</el-button>
          </el-form-item>
        </el-form>
      </el-aside>
      <el-container class="map-wrap">
        <div id="map-box"></div>
      </el-container>
    </div>
    <el-dialog title="选择车辆" :visible.sync="vinVisible" class="vin-dialog">
      <div>
        <div class="selectBox">
          <el-input class="selectInput" v-model="udeptName" @click.native="clickArea" placeholder="请选择部门"
            readonly></el-input>
          <div class="deptTree" :class="{ active: show == true }">
            <div class="custom-tree-container">
              <div class="block">
                <el-tree :data="udeptTreeData" node-key="id" @node-click="treeClick" default-expand-all
                  highlight-current :expand-on-click-node="false">
                </el-tree>
              </div>
            </div>
          </div>
        </div>
        <el-button v-if="hasPerm('news:push:info:list')" type="primary" @click="getVinList">查询</el-button>
        <el-button v-if="hasPerm('news:push:info:list')" @click="areaReset">取消</el-button>
        <div class="confirm">
          <el-button v-if="hasPerm('news:push:info:list')" type="primary" @click="confirmChoice">确认选择</el-button>
        </div>
        <el-table ref="vinTable" :data="vinData" tooltip-effect="dark" style="width: 100%" size="mini" stripe
          height="452px" @row-click="packageClickTableRow" @selection-change="packageSelectionChange"
          :row-key="getRowKeys">
          <el-table-column type="selection" width="24" align="center" style="padding: 0"
            :reserve-selection="true"></el-table-column>
          <el-table-column type="index" label="序号" width="55"></el-table-column>
          <el-table-column prop="vin" label="车架号"></el-table-column>
          <el-table-column prop="deptName" label="使用部门"></el-table-column>
          <el-table-column prop="personnelName" label="车辆绑定人"></el-table-column>
          <el-table-column prop="plateNum" label="车牌号"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script src="//webapi.amap.com/ui/1.1/main.js?v=1.1.1"></script>
<script>
import AMap from "AMap";
export default {
  data() {
    return {
      fenceForm: {
        name: "",
        vinList: [],
        PlateList: "",
        monitorType: "1",
        shapeType: "",
        startTime: "00:00",
        endTime: "23:59",
        monitorStatus: "1",
      },
      vinVisible: false,
      vinData: [],
      packageVal: [],
      show: false,
      udeptTreeData: [],
      udeptName: "",
      deptId: "",
      vinPlate: "",
      selectVinList: [],
      vinId: [],
      editTag: 0,
      //绘制围栏
      map: null,
      scale: null,
      mouseTool: null,
      overlays: [],
      circleCenter: [],
      circleRadius: "",
      polygonPath: [],
      strokeColor: "#090086",
      ploygonArea: "",
      areaOptions: [],
      adcode: [],
      optionProps: {
        value: "id",
        checkStrictly: true,
      },
      //修改时传递的圆心
      editCenter: "",
      editCenterArr: [],
    };
  },
  created() {
    this.getAreaList();
    this.getVinList();
    let gfid = sessionStorage.getItem("gfid");
    if (gfid) {
      this.editTag = "2";
      this.getFenceInfo(gfid);
    }
  },
  mounted() {
    this.init();
    //默认选中围栏类型时使用
    //this.fenceType()
  },
  methods: {
    goback() {
      this.$router.push("/Geofencing");
    },
    init() {
      let _this = this;
      this.map = new AMap.Map("map-box", {
        center: [120.211254, 30.255436],
        resizeEnable: true,
        zoom: 12,
        mapStyle: "amap://styles/fresh",
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });
      
      this.mouseTool = new AMap.MouseTool(this.map);
      AMap.event.addListener(this.mouseTool, "draw", function (e) {
        if (_this.fenceForm.shapeType == 1) {
          _this.circleCenter = e.obj.getCenter();
          _this.circleRadius = e.obj.getRadius();
          _this.mouseTool.close(true);
          _this.drawMap(1);
        } else if (_this.fenceForm.shapeType == 2) {
          _this.polygonPath = e.obj.getPath();
          _this.mouseTool.close(true);
          _this.drawMap(2);
        }
      });
    },
    async getAreaList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/area/list");
      if (res.code == 1) {
        _this.areaOptions = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    clickInput() {
      this.getDeptTree();
      this.getVinList();

      this.vinVisible = true;
      if (this.$refs.vinTable) {
        //清除选中但未保存row数据
        this.$refs.vinTable.clearSelection();
      }
      //根据row.id在表格中回显
      this.$nextTick(() => {
        this.vinData.forEach((row) => {
          if (this.vinId.indexOf(row.id) >= 0) {
            this.$refs.vinTable.toggleRowSelection(row, true);
          }
        });
      });
    },
    async getVinList() {
      let _this = this;
      let obj = {};
      obj.gfid = "";
      obj.deptId = _this.deptId;
      let { data: res } = await _this.$axios.get(
        "/api/geo/fence/vehicle/options",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.vinData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    areaReset() {
      this.udeptName = "";
      this.deptId = "";
      this.getVinList();
    },
    clickArea() {
      this.show = !this.show;
    },
    treeClick(data) {
      this.udeptName = data.label;
      this.deptId = data.id;
      this.show = !this.show;
    },
    async getDeptTree() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        _this.udeptTreeData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //确认选择
    confirmChoice() {
      let val = this.packageVal;
      // if (val.length == 0) {
      //   this.$message.warning("请先选择车辆")
      //   return
      // }
      this.vinPlate = "";
      this.selectVinList = [];
      this.vinId = [];
      for (let i = 0; i < val.length; i++) {
        if (this.vinPlate == "") {
          this.vinPlate = val[i].plateNum;
        } else {
          this.vinPlate = this.vinPlate + "、" + val[i].plateNum;
        }
        this.vinId.push(val[i].id);
        this.selectVinList.push(val[i].vin);
      }
      this.fenceForm.PlateList = this.vinPlate;
      this.vinVisible = false;
    },
    async saveFence() {
      let _this = this;
      let data = [];
      let obj = this.fenceForm;
      obj.vinList = this.selectVinList;
      if (obj.name == "") {
        _this.$message.warning("请输入围栏名称");
        return;
      }
      if (this.fenceForm.shapeType == 1) {
        if (this.circleCenter == "" && _this.editCenter == "") {
          _this.$message.warning("请设置围栏区域");
          return;
        }
        let centerPoint = "";
        if (this.circleCenter != "") {
          centerPoint = this.circleCenter.lng + "," + this.circleCenter.lat;
        } else {
          centerPoint = _this.editCenter;
        }
        obj.center = centerPoint;
        obj.radius = this.circleRadius;
      } else if (this.fenceForm.shapeType == 2) {
        if (this.polygonPath == "") {
          _this.$message.warning("请设置围栏区域");
          return;
        }
        if (this.ploygonArea > 100000000) {
          _this.$message.warning("围栏区域面积不能超过100平方公里");
          return;
        }
        if (_this.polygonPath.length > 100) {
          _this.$message.warning(
            "顶点数不能超过100个，现有" +
              _this.polygonPath.length +
              "个顶点，请调整。"
          );
          return;
        }
        obj.pointList = [];
        for (let i = 0; i < this.polygonPath.length; i++) {
          obj.pointList.push(this.polygonPath[i].lng);
          obj.pointList.push(this.polygonPath[i].lat);
        }
      } else if (this.fenceForm.shapeType == 4) {
        if (this.adcode.length == 0) {
          this.$message.warning("请设置行政区域");
          return;
        }
        let i = this.adcode.length;
        obj.adcode = this.adcode[i - 1];
      }
      if (_this.editTag == "0") {
        data = await _this.$axios.post("/api/geo/fence", obj);
      } else {
        obj.gfid = sessionStorage.getItem("gfid");
        data = await _this.$axios.patch("/api/geo/fence", obj);
      }
      let res = data.data;
      if (res.code == 1) {
        _this.map.clearMap();
        _this.clearData();
        //信息提示
        _this.$message.success("操作成功");
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //选择数据变化监控
    packageSelectionChange(val) {
      this.packageVal = val;
    },
    getRowKeys(row) {
      return row.id;
    },
    packageClickTableRow(row, event, column) {
      console.log(row);
      console.log(column);
      this.$refs.vinTable.toggleRowSelection(row);
    },
    //地理围栏绘制
    fenceType() {
      this.mouseTool.close(true);
      this.map.clearMap();
      if (this.fenceForm.shapeType == 4) {
        return;
      }
      this.draw(this.fenceForm.shapeType);
    },
    getAdcode() {
      this.drawMap(4);
    },
    draw(type) {
      let _this = this;
      switch (type) {
        case "1": {
          this.mouseTool.circle({
            fillColor: _this.strokeColor,
            strokeColor: _this.strokeColor,
            //同Circle的Option设置
          });
          break;
        }
        case "2": {
          this.mouseTool.polygon({
            fillColor: _this.strokeColor,
            strokeColor: _this.strokeColor,
            //同Polygon的Option设置
          });
          break;
        }
      }
    },
    drawMap(type) {
      let _this = this;
      //圆形围栏
      if (type == 1) {
        _this.map.clearMap();
        let center = [];
        if (_this.circleCenter == "") {
          center = _this.editCenterArr;
        } else {
          center = _this.circleCenter;
        }
        let circle = new AMap.Circle({
          center: center,
          radius: _this.circleRadius, //半径
          strokeColor: _this.strokeColor,
          strokeOpacity: 1,
          strokeWeight: 2,
          fillOpacity: 0.3,
          fillColor: _this.strokeColor,
        });
        circle.setMap(_this.map);
        var circleEditor = new AMap.CircleEditor(_this.map, circle);
        circleEditor.open();
        circleEditor.on("move", function (e) {
          _this.circleCenter = e.lnglat;
        });
        circleEditor.on("adjust", function (e) {
          _this.circleRadius = e.radius;
        });
      }
      //多边形围栏
      else if (type == 2) {
        _this.map.clearMap();
        let polygon = new AMap.Polygon({
          path: _this.polygonPath,
          strokeColor: _this.strokeColor,
          strokeWeight: 2,
          strokeOpacity: 1,
          fillOpacity: 0.3,
          fillColor: _this.strokeColor,
        });
        _this.map.add(polygon);
        var polyEditor = new AMap.PolyEditor(_this.map, polygon);
        polyEditor.open();
        polyEditor.on("addnode", function (e) {
          //获取围栏顶点坐标集
          _this.polygonPath = polygon.getPath();
          //获取围栏面积
          _this.ploygonArea = polygon.getArea();
        });
        polyEditor.on("adjust", function (e) {
          _this.polygonPath = polygon.getPath();
          _this.ploygonArea = polygon.getArea();
        });
        polyEditor.on("removenode", function (e) {
          _this.polygonPath = polygon.getPath();
          _this.ploygonArea = polygon.getArea();
        });
      }
      //区域围栏
      else if (type == 4) {
        let i = _this.adcode.length;
        _this.map.clearMap();
        AMapUI.loadUI(["geo/DistrictExplorer"], function (DistrictExplorer) {
          //创建一个实例
          _this.districtExplorer = new DistrictExplorer({
            map: _this.map,
          });
          let adcode = "";
          adcode = _this.adcode[i - 1];

          _this.districtExplorer.loadAreaNode(
            adcode,
            function (error, areaNode) {
              //更新地图视野
              _this.map.setBounds(areaNode.getBounds(), null, null, true);
              //清除已有的绘制内容
              _this.districtExplorer.clearFeaturePolygons();
              //绘制区域
              _this.districtExplorer.renderParentFeature(areaNode, {
                cursor: "default",
                bubble: true,
                strokeColor: _this.strokeColor, //线颜色
                strokeOpacity: 1, //线透明度
                strokeWeight: 2, //线宽
                fillColor: _this.strokeColor, //填充色
                fillOpacity: 0.3, //填充透明度
              });
            }
          );
        });
      }
      _this.$nextTick(() => {
        // 更改地图中心点
        _this.map.setZoom(10);
        //适应所有坐标点合适视野居中
        _this.map.setFitView();
      });
    },
    async getFenceInfo(gfid) {
      let _this = this;
      let obj = {
        gfid: gfid,
      };
      let { data: res } = await _this.$axios.get("/api/geo/fence/info", {
        params: obj,
      });
      if (res.code == 1) {
        let val = res.data;
        _this.fenceForm.name = val.name;
        for (let i = 0; i < val.vehicleList.length; i++) {
          _this.fenceForm.vinList.push(val.vehicleList[i].vin);
          _this.vinId.push(val.vehicleList[i].id);
          if (_this.fenceForm.PlateList == "") {
            _this.fenceForm.PlateList = val.vehicleList[i].plateNum;
          } else {
            _this.fenceForm.PlateList =
              _this.fenceForm.PlateList + "、" + val.vehicleList[i].plateNum;
          }
        }
        _this.fenceForm.monitorType = val.monitorType.toString();
        _this.fenceForm.shapeType = val.shapeType.toString();
        _this.fenceForm.startTime = val.startTime;
        _this.fenceForm.endTime = val.endTime;
        _this.fenceForm.monitorStatus = val.monitorStatus.toString();
        if (val.shapeType == 1) {
          let arr = val.center.toString().split(",");
          _this.editCenter = arr[0] + "," + arr[1];
          _this.editCenterArr = val.center.split(",");
          _this.circleRadius = val.radius;
        } else if (val.shapeType == 2) {
          _this.polygonPath = val.pointList;
        } else if (val.shapeType == 4) {
          _this.adcode = val.adcodeParent;
        }
        _this.mouseTool.close(true);
        _this.drawMap(val.shapeType);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    clearData() {
      this.$resetForm(this, "fenceForm");
      this.adcode = [];
      this.vinId = [];
      if (this.$refs.vinTable) this.$refs.vinTable.clearSelection();
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 48px;
  line-height: 48px;
  display: block;
  margin-bottom: 20px;
  padding-left: 20px;
  background-color: #fff;
}

.sub-title {
  padding-top: 20px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.con-wrap-inner {
  width: 100%;
  height: calc(100% - 68px);
  display: flex;
  flex-direction: row;
  background-color: #f8f8f8;
}

.left-con {
  height: auto;
  padding: 0 20px;
}

.con-wrap-inner .el-container {
  background-color: #fff;
}

.input-form-inline {
  p {
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }

  /deep/ .radios .el-form-item__content {
    line-height: 18px;
  }

  .btn /deep/ {
    margin-top: 20px;

    .el-form-item__content {
      text-align: center;
    }

    .el-button {
      width: 160px;
      height: 32px;
    }
  }
}

//地图样式
.map-wrap {
  flex-direction: column;
  width: 100%;
  border: 1px solid #ccc;

  #map-box {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}

//区域查询
.selectBox {
  display: inline-block;
  width: 300px;
  position: relative;
  margin-right: 20px;
}

.selectBox .selectInput /deep/ .el-input__inner {
  cursor: pointer !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.confirm {
  margin: 20px 0;
}

.deptTree {
  width: 100%;
  height: 540px;
  overflow: auto;
  margin-left: 18px;
  position: absolute;
  top: 40px;
  left: -18px;
  font-size: 14px;
  display: none;
  z-index: 2;
}

.deptTree.active {
  display: block;
}

.el-cascader {
  width: 100%;
}
</style>
